export default __webpack_public_path__ + "static/media/Repeater.41dbda15.svg";